export const listGlobals = {
  unstyled: {
    listStyle: "none",
    p: [0, 0, 0, 0],
    m: [0, 0, 0, 0],
  },
}
